import { api } from "./api";

export const cashInApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCashIn: builder.query({
      query: () => "api/Fin/CashIn",
      providesTags: ["cashIn"],
    }),
    addCashIn: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/CashIn",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["cashIn"],
    }),
  }),
});

export const { useGetCashInQuery, useAddCashInMutation } = cashInApi;
